import React from 'react';
import { Button, Box, CircularProgress, Tooltip } from '@mui/material';
import { Print } from '@mui/icons-material';

interface PrintButtonsProps {
    onPrint: () => void;
    onExportPDF?: () => void;
    isPrinting: boolean;
    printLabel?: string;
    pdfLabel?: string;
    showPDF?: boolean;
    disabled?: boolean;
}

const PrintButtons: React.FC<PrintButtonsProps> = ({
    onPrint,
    onExportPDF,
    isPrinting,
    printLabel = 'Print',
    pdfLabel = 'PDF',
    showPDF = true,
    disabled = false
}) => {
    return (
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }} className="no-print">
            <Tooltip title="Refresh before Print">
                <Button
                    variant="contained"
                    color='secondary'
                    startIcon={isPrinting ? <CircularProgress size={20} /> : <Print />}
                    onClick={onPrint}
                    disabled={isPrinting || disabled}
                    size="small"
                >
                    {isPrinting ? 'Printing...' : printLabel}
                </Button>
            </Tooltip>

        </Box>
    );
};

export default PrintButtons;